import { BaseService } from "@/shared/services";

class StudentService extends BaseService {
  endpoint = "students";
}

export default new StudentService();
